import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth.jsx';
import { useLoading } from '@/contexts/LoadingContext';
import { useEffect } from 'react';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading: authLoading, userInfo, logout } = useAuth();
    const { showLoading, hideLoading } = useLoading();
    const location = useLocation();

    useEffect(() => {
        if (authLoading) {
            showLoading('加载中...');
        } else {
            hideLoading();
        }
        // 离开受保护路由时关掉 loading，避免残留
        return () => hideLoading();
    }, [authLoading, showLoading, hideLoading]);

    if (authLoading) {
        return null; // 内容由 LoadingProvider 的全局遮罩承担
    }

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname }}
            />
        );
    }

    // URL 参数 username 校验
    const params = new URLSearchParams(location.search);
    const urlUsername = params.get('username');
    if (urlUsername && userInfo?.username && urlUsername !== userInfo.username) {
        // 身份不匹配，调用 logout 清除登录态，跳转登录
        logout();
        return (
            <Navigate
                to="/login"
                replace
                state={{ from: location.pathname }}
            />
        );
    }

    return children;
};


export default ProtectedRoute;